export default{
    client: {
        index: 'client-index',
    }
}